var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.5 4.465c0 .69-.248 1.283-.742 1.777l-13.75 13.75-4.571.508c-.286 0-.521-.104-.703-.313-.182-.208-.26-.455-.234-.742l.508-4.453 13.75-13.75C15.252.748 15.845.5 16.535.5s1.282.248 1.777.742l1.446 1.445c.494.495.742 1.088.742 1.778zm-4.766 4.043l-3.242-3.242L2.18 15.578l-.391 3.633 3.633-.391L15.734 8.508zm3.516-4.043c0-.352-.117-.645-.352-.879l-1.484-1.484c-.234-.235-.527-.352-.879-.352-.351 0-.644.117-.879.352l-2.265 2.265 3.242 3.242 2.265-2.265c.235-.235.352-.528.352-.879z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIconBlack);
export default __webpack_public_path__ + "static/media/pencilIconBlack.b38eefc5cb8dadcc51cff38d09822907.svg";
export { ForwardRef as ReactComponent };